import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import budgetDriversQueryKeys from './budgetDriversQueryKeys'
import { BudgetDriver } from '../../../types/budgetDriver/BudgetDriver'
import { updateBudgetDriver } from '../service/budgetDriversService'

export const useUpdateBudgetDriver = () => {
  const companyId = useSelector(contextCompanyIdSelector)
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const { message } = App.useApp()

  if (!companyId) {
    throw new Error('Company ID is required for budget drivers.')
  }

  return useMutation({
    mutationKey: ['budget', 'budgetDriver', 'update'],
    mutationFn: (data: BudgetDriver) => updateBudgetDriver(data, companyId),
    onSuccess() {
      message.success(t('messages:updateSuccess', 'Updated successfully'))
      queryClient.invalidateQueries({ queryKey: budgetDriversQueryKeys.list({ companyId }) })
    },
    onError(error) {
      message.error(error.message || t('messages:updateError', 'Failed to update'))
    }
  })
}
